import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { handleChange, handleSubmit, handleUpdate } from "../../Controller/Client/CreateClientController";
import { SuperAdminModel } from "../../Model/SuperAdminModel";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import UserService from "../../../Setup/controller/UserController/UserController";
import VersionService from "../../../Setup/controller/VersionController/VersionController";
function CreateClient({ company, onClose, onSuccess }) {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [userNameErrors, setUserNameError] = useState({});
    const [formData, setFormData] = SuperAdminModel();
    const [CountryList, setCountries] = useState([]);
    const [VersionList, setVersionList] = useState([]);
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    const [loading, setLoading] = useState(false);
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const fetchVersion = async () => {
        try {
            const listOfVersion = await VersionService.GetAllVersion();
            setVersionList(listOfVersion);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    useEffect(() => {
        fetchCountries();
        fetchVersion();
        if (company) {
            const startDate = company.StartDate ? new Date(company.StartDate).toISOString().split('T')[0] : '';
            const endDate = company.EndDate ? new Date(company.EndDate).toISOString().split('T')[0] : '';
            setFormData({
                CompanyName: company.CompanyName, ContractPrefix: company.ContractPrefix, StartDate: startDate,
                EndDate: endDate, Town: company.Town, Contact: company.Contact, Country: company.Country,
                Email: company.Email, VATReg: company.VATReg, Fax: company.Fax, County: company.County,
                Telephone: company.Telephone, Address1: company.Address1, Address2: company.Address2,
                UserPassword: company.UserPassword, UserName: company.UserName, AllowedUsers: company.AllowedUsers,
                VersionID: company.VersionID, FinancialSoftware: company.FinancialSoftware

            });
        } else {
            setFormData({
                CompanyName: '', ContractPrefix: '', StartDate: '', EndDate: '', Town: '', Contact: '', Country: '',
                Email: '', VATReg: '', Fax: '', County: '', Telephone: '', Address1: '', Address2: '',
                UserPassword: '', UserName: '', AllowedUsers: '0', VersionID: '0', FinancialSoftware: "0"
            }); // Clear form data when switching to add mode
        }
    }, [company, setFormData]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const checkEmailExistence = async (redirectCallback, email) => {
        try {
            const response = await UserService.IsEmailExist(redirectCallback, email);
            return response.length;
        } catch (error) {
            console.error('Error checking email existence:', error);
            return false;
        }
    };
    const checkCompanyEmailExistence = async (redirectCallback, email) => {
        try {
            const response = await UserService.IsCompanyEmailExist(redirectCallback, email);
            return response.length;
        } catch (error) {
            console.error('Error checking email existence:', error);
            return false;
        }
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        setLoading(true);
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/ClientList?saved=true');
        };

        const onSuccessCallback = () => {
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
          //  redirectUserList();
        };

        formData.Languages = selectedLanguages.map(lang => lang.ID).join(',');

        if (company) {
            formData.CoSetupID = company.CoSetupID;
            handleUpdate(formData, setFormData, setErrors, onSuccessCallback, onSuccessCallback, onSuccessCallback);
        } else {
            const emailExists = await checkEmailExistence(redirectCallback, formData.UserName);
            const companyEmailExists = await checkCompanyEmailExistence(redirectCallback, formData.Email);
            if (emailExists > 0) {
                setLoading(false);
                setErrors(prevErrors => ({ ...prevErrors, UserName: 'UserName already exists' }));
                return;
            }
            else if (companyEmailExists > 0) {
                setErrors(prevErrors => ({ ...prevErrors, Email: 'Email already exists' }));
                setLoading(false);
                return;
            }
            else {
                formData.CoSetupID = 0;
                const postData = await handleSubmit(formData, setFormData, setErrors, redirectCallback, onSuccessCallback, onSuccessCallback);
                setLoading(false);
                return false;
            }
        }
        onSuccess();
        setLoading(false);
    };

    const ClientLanguages = JSON.parse(localStorage.getItem('ClientLanguages')) || [];
    const [availableLanguages, setAvailableLanguages] = useState(ClientLanguages.filter(lang => lang.ID !== 1));
    const [selectedLanguages, setSelectedLanguages] = useState([{ ID: 1, Language: 'English' }]); // Include English by default
    const [selectedAvailableLanguage, setSelectedAvailableLanguage] = useState(null);
    const [selectedSelectedLanguage, setSelectedSelectedLanguage] = useState(null);

    const handleSelectLanguage = () => {
        if (selectedAvailableLanguage) {
            setAvailableLanguages(availableLanguages.filter(lang => lang.ID !== selectedAvailableLanguage.ID));
            setSelectedLanguages([...selectedLanguages, selectedAvailableLanguage]);
            setSelectedAvailableLanguage(null);
        }
    };

    const handleDeselectLanguage = () => {
        if (selectedSelectedLanguage && selectedSelectedLanguage.ID !== 1) { // Ensure English is not deselectable
            setSelectedLanguages(selectedLanguages.filter(lang => lang.ID !== selectedSelectedLanguage.ID));
            setAvailableLanguages([...availableLanguages, selectedSelectedLanguage]);
            setSelectedSelectedLanguage(null);
        }
    };
    return (
        <div>
            {loading && (
                <div class="loading" style={{ zIndex: "10000" }}>
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade clientModal show d-block" id="clientModal" tabIndex="-1" aria-labelledby="clientModal" aria-hidden="true" data-backdrop="static">


                    <div class="modal-dialog modal-xl">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Create Client</h5>
                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label for="inputText" className="col-sm-2 col-form-label">{t('clientName')}:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="CompanyName" value={formData.CompanyName} onChange={handleFieldChange} />
                                        {errors.CompanyName && <div style={{ color: 'red' }}>{errors.CompanyName}</div>}


                                    </div>

                                </div>
                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label for="inputText" className="col-sm-2 col-form-label">{t('subscriptionDate')}:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <input type="date" className='form-control' name="StartDate" value={formData.StartDate} onChange={handleFieldChange} />
                                        {errors.StartDate && <div style={{ color: 'red' }}>{errors.StartDate}</div>}


                                    </div>
                                    <label for="inputText" className="col-sm-2 col-form-label">{t('expiryDate')}:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <input type="date" maxLength="3" className='form-control' name="EndDate" value={formData.EndDate} onChange={handleFieldChange} />
                                        {errors.EndDate && <div style={{ color: 'red' }}>{errors.EndDate}</div>}
                                    </div>
                                </div>
                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">{t('selectLanguage')}:</label>

                                    <div className="col-sm-4">
                                        <select multiple className="form-control" size="4" onChange={(e) => setSelectedAvailableLanguage(availableLanguages.find(lang => lang.ID === parseInt(e.target.value)))}>
                                            {availableLanguages.map(language => (
                                                <option key={language.ID} value={language.ID}>
                                                    {language.Language}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="row">
                                            <div className="col-sm-3 d-flex flex-column align-items-center ">
                                                <button type="button" className="btn btn-outline-success mt-3" onClick={handleSelectLanguage}>
                                                    &gt;&gt;
                                                </button>
                                                <button type="button" className="btn btn-outline-success mt-3" style={{ "marginTop": "5px" }} onClick={handleDeselectLanguage}>
                                                    &lt;&lt;
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <select multiple className="form-control" size="4" onChange={(e) => setSelectedSelectedLanguage(selectedLanguages.find(lang => lang.ID === parseInt(e.target.value)))}>
                                            {selectedLanguages.map(language => (
                                                <option key={language.ID} value={language.ID}>
                                                    {language.Language}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>

                                    <label for="inputText" className="col-sm-2 col-form-label">{t('email')}:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Email" value={formData.Email}
                                            onChange={handleFieldChange}
                                            readOnly={!!company}
                                        />
                                        {errors.Email && <div style={{ color: 'red' }}>{errors.Email}</div>}
                                    </div>

                                    <label for="inputText" className="col-sm-2 col-form-label">{t('country')}:</label>
                                    <div className="col-sm-4">
                                        <select name="Country" className='form-control' value={formData.Country} onChange={handleFieldChange}>
                                            <option value="0">Select Country</option>
                                            {CountryList.map((country) => (
                                                <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                    {country.vc_CountryName}
                                                </option>
                                            ))}
                                        </select>

                                        {errors.Country && <div style={{ color: 'red' }}>{errors.Country}</div>}
                                    </div>
                                </div>


                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label for="inputText" className="col-sm-2 col-form-label">User Name:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="UserName" value={formData.UserName} onChange={handleFieldChange} readOnly={!!company} />
                                        {errors.UserName && <div style={{ color: 'red' }}>{errors.UserName}</div>}
                                    </div>



                                    <label for="inputText" className="col-sm-2 col-form-label">{t('contact')}:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Contact" value={formData.Contact} onChange={handleFieldChange} />
                                        {errors.Contact && <div style={{ color: 'red' }}>{errors.Contact}</div>}
                                    </div>

                                </div>
                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label for="inputText" className="col-sm-2 col-form-label">Password:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="UserPassword" value={formData.UserPassword} onChange={handleFieldChange} />
                                        {errors.UserPassword && <div style={{ color: 'red' }}>{errors.UserPassword}</div>}
                                    </div>

                                    <label for="inputText" className="col-sm-2 col-form-label">{t('town')}:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Town" value={formData.Town} onChange={handleFieldChange} />
                                        {errors.Town && <div style={{ color: 'red' }}>{errors.Town}</div>}
                                    </div>

                                </div>
                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label for="inputText" className="col-sm-2 col-form-label">{t('vatRegistration')}:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="VATReg" value={formData.VATReg} onChange={handleFieldChange} />
                                        {errors.VATReg && <div style={{ color: 'red' }}>{errors.VATReg}</div>}
                                    </div>
                                    <label for="inputText" className="col-sm-2 col-form-label">{t('fax')}:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Fax" value={formData.Fax} onChange={handleFieldChange} />
                                        {errors.Fax && <div style={{ color: 'red' }}>{errors.Fax}</div>}
                                    </div>

                                </div>
                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label for="inputText" className="col-sm-2 col-form-label">{t('county')}:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="County" value={formData.County} onChange={handleFieldChange} />
                                        {errors.County && <div style={{ color: 'red' }}>{errors.County}</div>}
                                    </div>
                                    <label for="inputText" className="col-sm-2 col-form-label">{t('telephone')}</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Telephone" value={formData.Telephone} onChange={handleFieldChange} />
                                        {errors.Telephone && <div style={{ color: 'red' }}>{errors.Telephone}</div>}
                                    </div>

                                </div>
                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label for="inputText" className="col-sm-2 col-form-label">{t('address1')}:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Address1" value={formData.Address1} onChange={handleFieldChange} />
                                        {errors.Address1 && <div style={{ color: 'red' }}>{errors.Address1}</div>}
                                    </div>
                                    <label for="inputText" className="col-sm-2 col-form-label"></label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="Address2" value={formData.Address2} onChange={handleFieldChange} />
                                        {errors.Address2 && <div style={{ color: 'red' }}>{errors.Address2}</div>}
                                    </div>

                                </div>
                                <div className="row" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label for="inputText" className="col-sm-2 col-form-label">Allowed Users:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className='form-control' name="AllowedUsers" value={formData.AllowedUsers} onChange={handleFieldChange} />
                                        {errors.AllowedUsers && <div style={{ color: 'red' }}>{errors.AllowedUsers}</div>}
                                    </div>
                                    <label for="inputText" className="col-sm-2 col-form-label">Select Version:</label>
                                    <div className="col-sm-4">
                                        <select name="VersionID" className='form-control' value={formData.VersionID} onChange={handleFieldChange}>
                                            <option value="0">Select Version</option>
                                            {VersionList.map((version) => (
                                                <option key={version.ID} value={version.ID}>
                                                    {version.Name}
                                                </option>
                                            ))}
                                        </select>

                                        {errors.VersionID && <div style={{ color: 'red' }}>{errors.VersionID}</div>}
                                    </div>


                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "5px", "marginTop": "5px" }}>
                                    <label for="inputText" className="col-sm-2 col-form-label">Financial Software</label>
                                    <div className="col-sm-4">
                                        <select name="FinancialSoftware" className='form-control' value={formData.FinancialSoftware}
                                            onChange={handleFieldChange}
                                        >
                                            <option value="0">Select Financial Software</option>
                                            <option value="1">Sage</option>
                                            <option value="4">Sage 50</option>
                                            <option value="2">Quickbook</option>
                                            <option value="3">Xero</option>

                                        </select>


                                    </div>

                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-outline-success mt-3">{t('submit')}</button>

                            </div>

                        </div>
                    </div>
                </div>




















            </form>
        </div>
    );
};

export default CreateClient;